import { getDateTime } from "../../services/CheckMeProBlePackages";
import { decodeString } from "../../services/EshBleUtils";
import { ECGInnerItem    } from "./ECGInnerItem";
export interface CheckMeProUser{

    id: number
    name: string
    sex: number
    birthday: Date
    ico : number
    weight:number
    height:number
    medicalId: number
    color: number
        
}

export function parseCheckMeProUser (bytes: number[] ) : CheckMeProUser[]{
    
    let start = 0
      const returnList:  CheckMeProUser[] = new Array();
    for (let k = 0; k < bytes.length -8; k++) {
        start = k * 27
        if ( start >= bytes.length)
            break;
        const user = {} as CheckMeProUser
        returnList.push(user)


        user.id =  bytes[start]
        user.name = decodeString(bytes, start + 1, 16).trim();
        user.ico = bytes[start + 17]
        user.sex = bytes[start + 18]

        user.birthday= getDateTime(bytes,start + 19)
        if (bytes.length< start + 23  )
            return;

        user.weight = (bytes[start + 23] & 0xff) + ((bytes[start + 24] & 0xff) << 8); 
        user.height = (bytes[start + 25] & 0xff) + ((bytes[start + 26] & 0xff) << 8) /100; 
    }

    return returnList;

}

